
<!-- 根据区域检索摄像头 -->
<template>
  <div class="bu-ramera">
    <div class="title" :model="title">
      {{ title }}
    </div>
    <div class="tree-list-container sbar">
      <div class="areaTree">
        <el-scrollbar style="height:100%;">
          <!--<el-input placeholder="输入关键字进行过滤" v-model="areaText"></el-input>-->
          <el-tree
            ref="tree2"
            class="filter-tree"
            :data="dataList"
            :props="defaultProps"
            :show-checkbox="false"
            highlight-current
            :filter-node-method="filterNode"
            @node-click="getCheckNode"
          >
            <span slot-scope="{ node }" class="custom-tree-node">
              <span :title="node.label">{{ node.label | ellipsis(8) }}</span>
            </span>
          </el-tree>
        </el-scrollbar>
      </div>
      <div class="device_list sbar">
        <div style="width:250px">
          <el-input v-model="devText" :placeholder="this.$t('deviceMg.placeholder.cameraName')" clearable @keyup.enter.native="searDev" @clear="searDev">
            <el-button v-if="isShowButton" slot="append" icon="el-icon-search" @click="searDev"></el-button>
          </el-input>
          <el-scrollbar ref="deviceList" style="height:310px">
            <el-checkbox-group v-model="checkList" @change="selectCh">
              <div v-for="(item,index) in tableData" :key="index" class="m10 mb20">
                <el-checkbox :label="item.deviceId" @change="selectChItem(item)">{{ item.deviceName }}</el-checkbox>
              </div>
            </el-checkbox-group>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { Base, Log } from '$utils'
export default {
  props: {
    deviceType: {
      type: Number,
      default: 18
    },
    cameraFeature: {
      type: Number,
      default: 0
    },
    isShowButton: {
      type: Boolean,
      default: false
    },
    ischild: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      totalPage: '',
      searchParam:{
        area: '', //区域相关的deviceId: "",
        deviceName: '',
        deviceType: this.deviceType,
        page: 1,
        pageSize: 50,
        parentCodes: '', //区域相关的，父级code
        status: ''
      },
      // 滚动条相关
      deviceList: null,
      boxScrollContainer: '',
      scrollView: '',
      areaCode: '',
      checkList: [],
      searchForm: {},
      title: this.isShowButton ? this.$t('carPatrolFeature.title.camera'): this.$t('deviceMg.label.area'),
      areaText:'',
      devText: '',
      dataList: [],
      defaultProps: {
        children: 'areaChildren',
        label: 'areaDevGroupName',
        id: 'areaDevGroupCode'
      },
      tableData: []
    }
  },
  watch: {
    areaText(val) {
      this.$refs.tree2.filter(val)
    }
  },
  mounted() {
    this.queryDevice()
    this.scrollbar()
  },
  methods: {
    selectChItem(val){
      const result = this.checkList.some(item => {
        if(item === val.deviceId){
          return true;
        }
      })
      if(result === true){
        if(!val.longitude){
          this.$message.warning(this.$t('deviceMg.message.coordinate'))
        }
      }
    },
    // 获取设备列表
    getDeviceList(params) {
      console.log('params', params)
      if(this.ischild){
        params.ischild = this.ischild;
      }
      this.$fetch('/bms/device/getDeviceListByPage.json', params).then(res =>{
        if(!res.success) {
          this.$message.error(res.msgContent)
          return
        }
        this.tableData = this.tableData.concat(res.returnObj.list)
        this.totalPage = res.returnObj.pages
      })
    },
    // 防抖动的方式从远端获取设备
    getRemoteDev(that){
      let _this = that
      return _.debounce(function(){
        _this.searchParam.pageSize = 50
        _this.searchParam.deviceName = _this.devText
        _this.searchParam.area = _this.areaCode
        _this.searchParam.cameraFeature = _this.cameraFeature
        _this.getDeviceList(_this.searchParam)
      }, 800)
    },
    // getRemoteDev: _.debounce(function () {
    //   this.searchParam.pageSize = 50
    //   this.searchParam.deviceName = this.devText
    //   this.searchParam.area = this.areaCode
    //   this.camerafeature && (this.searchParam.camerafeature = this.camerafeature)
    //   this.getDeviceList(this.searchParam)
    // },800),
    // 搜索设备
    searDev() {
      this.tableData = []
      this.getRemoteDev()
    },
    // 单个选择回调
    selectCh(selection) {
      const resultArr = _.filter(this.tableData, function(o) {
        return selection.includes(o.deviceId);
      })
      this.$emit('careraData', resultArr)
    },
    // 查询区域树
    queryDevice() {
      this.$fetch(
        '/cms/area/queryAreaByAccountName.json',
      ).then(response => {
        if (!response.success) {
          this.$message.error(this.$t('carPatrolFeature.message.searchNo'))
          return
        } else {
          this.dataList = response.returnObj
        }
      })
    },
    filterNode(value, data) {
      if (!value) {
        return true
      }else{
        return data.areaDevGroupName.indexOf(value) !== -1
      }
    },
    getCheckNode(data) {
      this.tableData = []
      this.searchParam.page = 1
      this.searchParam.deviceName = this.devText = ''
      this.searchParam.area = data.areaDevGroupCode
      this.areaCode = data.areaDevGroupCode
      this.searchParam.cameraFeature = this.cameraFeature
      //this.camerafeature && (this.searchParam.camerafeature = this.camerafeature)
      this.getDeviceList(this.searchParam)
    },
    scrollbar() {
      this.deviceList = this.$refs.deviceList
      this.boxScrollContainer = this.deviceList.$el.querySelector(
        '.el-scrollbar__wrap'
      )
      this.scrollView = this.boxScrollContainer.querySelector(
        '.el-scrollbar__view'
      )
      this.scrollFun = e => {
        if (this.scrollView.clientHeight - e.srcElement.scrollTop - e.srcElement.scrollWidth === 30) {
          if(this.searchParam.page < this.totalPage) {
            this.searchParam.page++
            this.getDeviceList(this.searchParam)
          }
        }
      }
      this.boxScrollContainer.addEventListener('scroll', this.scrollFun)
    }
  }
}
</script>
<style scoped>
    .tree-list-container {
        margin: 0 auto 0 0;
        display: flex;
        flex: 1;
    }
    .title {
        width: 100%;
        font-size: 16px;
        height: 20px;
    }
    .bu-ramera {
        min-width: 500px;
        width: 100%;
        height: 430px;
        border: 1px solid #0574e0;
        background-color: rgba(36, 55, 94,.8);
        padding: 10px 15px;
    }
    .areaTree {
        height: 340px;
        flex: 1;
        min-width: 180px;
    }
    .device_list {
        margin-left: 10px;
        flex: 1;
        position: relative;
    }
    .el-tree {
        height: 340px;
        background:#0d121c
    }
</style>


